module.exports = __webpack_public_path__ + "img/urbi-01.c17cf9a6.jpg";